import React from 'react';
import { Section } from '../components/Section';
import { Card } from '../components/Card';
import { Button } from '../components/Button';
import { TrendingUp, Clock, DollarSign } from 'lucide-react';
export function CaseStudy() {
  return <div className="pt-20" data-id="element-95">
      {/* Hero */}
      <div className="bg-[#1a202c] text-white py-20" data-id="element-96">
        <div className="container mx-auto px-4 md:px-6" data-id="element-97">
          <div className="max-w-3xl" data-id="element-98">
            <div className="inline-block px-3 py-1 bg-white/10 rounded-lg text-sm font-medium mb-6" data-id="element-99">
              Case Study: TechCorp Inc.
            </div>
            <h1 className="text-4xl md:text-5xl font-bold leading-tight mb-8" data-id="element-100">
              How TechCorp eliminated manual purchase requests and saved 15
              hours per week
            </h1>
            <div className="flex gap-8 text-white/80" data-id="element-101">
              <div data-id="element-102">
                <p className="text-3xl font-bold text-[#EC4899]" data-id="element-103">15hrs</p>
                <p className="text-sm" data-id="element-104">Saved Per Week</p>
              </div>
              <div data-id="element-105">
                <p className="text-3xl font-bold text-[#EC4899]" data-id="element-106">100%</p>
                <p className="text-sm" data-id="element-107">Accurate Data</p>
              </div>
              <div data-id="element-108">
                <p className="text-3xl font-bold text-[#EC4899]" data-id="element-109">50+</p>
                <p className="text-sm" data-id="element-110">Team Members</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Section className="bg-white" data-id="element-111">
        <div className="container mx-auto px-4 md:px-6" data-id="element-112">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12" data-id="element-113">
            <div className="md:col-span-2 space-y-8" data-id="element-114">
              <div data-id="element-115">
                <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-116">
                  The Challenge
                </h2>
                <p className="text-gray-600 leading-relaxed" data-id="element-117">
                  TechCorp's procurement team was drowning in incomplete
                  purchase requests. Engineers would send screenshots or links
                  without proper item details, leading to constant
                  back-and-forth emails and delayed approvals.
                </p>
              </div>
              <div data-id="element-118">
                <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-119">
                  The Solution
                </h2>
                <p className="text-gray-600 leading-relaxed" data-id="element-120">
                  TechCorp deployed Cart Tracker to their entire engineering
                  team. Now, every purchase request includes complete item
                  details, SKUs, and pricing automatically captured from vendor
                  websites.
                </p>
                <ul className="mt-4 space-y-2" data-id="element-121">
                  <li className="flex items-center gap-2 text-gray-700" data-id="element-122">
                    <div className="w-2 h-2 bg-[#6366F1] rounded-full" data-id="element-123"></div>
                    One-click cart capture from Amazon and other vendors
                  </li>
                  <li className="flex items-center gap-2 text-gray-700" data-id="element-124">
                    <div className="w-2 h-2 bg-[#6366F1] rounded-full" data-id="element-125"></div>
                    Excel exports sent directly to procurement team
                  </li>
                  <li className="flex items-center gap-2 text-gray-700" data-id="element-126">
                    <div className="w-2 h-2 bg-[#6366F1] rounded-full" data-id="element-127"></div>
                    Complete product information every time
                  </li>
                </ul>
              </div>
              <div data-id="element-128">
                <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-129">
                  The Results
                </h2>
                <p className="text-gray-600 leading-relaxed" data-id="element-130">
                  Within one month, TechCorp eliminated 95% of incomplete
                  purchase requests. The procurement team now processes requests
                  3x faster, and engineers spend less time on administrative
                  tasks.
                </p>
              </div>
            </div>

            <div className="md:col-span-1" data-id="element-131">
              <Card className="p-6 sticky top-24" data-id="element-132">
                <h3 className="font-bold text-gray-900 mb-4" data-id="element-133">
                  Company Profile
                </h3>
                <div className="space-y-4 text-sm" data-id="element-134">
                  <div data-id="element-135">
                    <p className="text-gray-500" data-id="element-136">Industry</p>
                    <p className="font-medium" data-id="element-137">Enterprise Software</p>
                  </div>
                  <div data-id="element-138">
                    <p className="text-gray-500" data-id="element-139">Headquarters</p>
                    <p className="font-medium" data-id="element-140">San Francisco, CA</p>
                  </div>
                  <div data-id="element-141">
                    <p className="text-gray-500" data-id="element-142">Employees</p>
                    <p className="font-medium" data-id="element-143">450+</p>
                  </div>
                  <div data-id="element-144">
                    <p className="text-gray-500" data-id="element-145">Use Case</p>
                    <p className="font-medium" data-id="element-146">Engineering procurement</p>
                  </div>
                </div>
                <div className="mt-8 pt-6 border-t border-gray-100" data-id="element-147">
                  <p className="italic text-gray-600 mb-4" data-id="element-148">
                    "Cart Tracker transformed our procurement process. No more
                    chasing engineers for missing information."
                  </p>
                  <p className="font-bold text-sm" data-id="element-149">Jennifer Wu</p>
                  <p className="text-xs text-gray-500" data-id="element-150">
                    Procurement Manager, TechCorp
                  </p>
                </div>
              </Card>
            </div>
          </div>
        </div>
      </Section>

      <Section className="bg-[#6366F1] text-white" data-id="element-151">
        <div className="container mx-auto px-4 text-center" data-id="element-152">
          <h2 className="text-3xl font-bold mb-6" data-id="element-153">
            Ready to achieve similar results?
          </h2>
          <Button variant="secondary" className="px-8" onClick={() => window.open('https://calendly.com/alex-thruline/cart-tracker', '_blank')} data-id="element-154">
            Schedule a Demo
          </Button>
        </div>
      </Section>
    </div>;
}